import React, {useContext, useState, useRef, useEffect} from 'react';
import store from 'store';
import 'firebase/auth';
import {Redirect} from 'react-router-dom';

import imgss from '../image/innova_students.png';
import innova from '../image/innova.png';

import {AuthContext} from '../hooks/context/authContext';
import {validateLogin} from '../consumers/backendConsumer';
import {auth, googleProvider} from '../services/firebase';
import {EMAIL, PHOTO_URL} from '../constants';
import {Wrapper, Intranet} from '../components/atoms/WrapperLogin';
import { isNullOrUndefinded } from '../helper/utils';

const Login = ({url}) => {
    const {dispatch, state} = useContext(AuthContext);
    const [isLogging, setIsLogging] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const isMounted = useRef(true);
    useEffect(() => () => { isMounted.current = false; }, []);

    const validateLog = async (email, photo) => {
        setIsLogging(true);
        try {
            const response = await validateLogin(email, photo);
            if (response.status === 200) {
                return await dispatch({
                    type: 'LOGIN',
                    payload: {
                        user: {
                            email: response.data.data.Email,
                            id_usuario: response.data.data.IdUsuario,
                            id_empleado: response.data.data.IdEmpleado,
                            name: response.data.data.Nombre,
                            fullName: response.data.data.NombreCompleto,
                            photo: response.data.data.ProfileImageUrl,
                        },
                        token: response.data.data.AuthToken,
                        isLoggedIn: true,
                        role: response.data.data.Roles,
                        roleIds: response.data.data.IdRoles,
                        terms: response.data.data.showTermsMessage,
                        cookies: response.data.data.showCookiesMessage,
                        cookiesMessage: response.data.data.CookiesMessage,
                        isInterno: response.data.data.EsInterno
                    },
                });
            } else {
                if (isMounted.current) {
                    setErrorMessage(response.response.data.Message);
                    setError(true);
                }
            }
        } catch (e) {
            if (isMounted.current) setError(true);
            console.error('error', e);
        } finally {
            if (isMounted.current) setIsLogging(false);
        }
    };

    const signInWithGoogle = () => {
        auth
            .signInWithPopup(googleProvider)
            .then((res) => {
                console.debug("res: ", res);
                console.debug("user: ", res?.user);
                if (res.user.email !== null) {
                    validateLog(res.user.email, res.user.photoURL);
                    store.set(EMAIL, res.user.email);
                    store.set(PHOTO_URL, res.user.photoURL);
                }
            })
            .catch((e) => {
                console.error(e.message);
            })
    };

    if (state.isLoggedIn) {
        //return <Redirect to={{pathname: isNullOrUndefinded(url) ? '/' : url.from, state:{search: url?.search}}}/>;
        return <Redirect to="/" />;
    }
    return (
        <Wrapper>
            <Intranet image={imgss}/>

            <div className='login'>
                <div className='wrapperButtons'>
                    <div className='container-button'>
                        <img src={innova} alt='' style={{width: '50%'}}/>
                    </div>
                    <div className='container-button-mob'>
                        <img src='https://intranetinnova.github.io/IntranetFileRepository/Logos/innova_mob.png' alt='' style={{width: '50%'}}/>
                    </div>
                    <div className='container-button1'>
                        <button onClick={signInWithGoogle} className="font-gothan-light button-resett">
                            {isLogging
                                ?   <svg className='spinner' viewBox="25 25 50 50">
                                        <circle cx="50" cy="50" r="20" fill="none" className="path"></circle>
                                    </svg>
                                : "COMENCEMOS"
                            }
                        </button>
                        <div className="mensajes-error-inicio-sesion">
                            {state.notificationMessage && <p>{state.notificationMessage}</p>}
                            {error && (<p>{errorMessage}</p>)}
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default Login;
